'use client'
import { socket } from '../Containers/MainContainer';

import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

function PlutoSameEmail(props) {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [users, setUsers] = useState([]);
    const [ip, setIP] = useState([]);
    const [rank, setRank] = useState(0)

    useEffect(() => {

        socket.on('response_get_admin_sameemail_users', (data) => {
            setUsers(data.users)
            setRank(data.rank)
        })

        socket.emit('getSameEmailAdmin', {
            email: props.second_page.split('1').join('%'),
        })

    }, [])
    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>

                {/* Table Card */}
                <div style={{
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div style={{ padding: '16px 20px', borderBottom: '1px solid #21262d' }}>
                        <p style={{ color: '#e6edf3', fontWeight: '600', fontSize: '16px' }}>Same Email User Details</p>
                    </div>

                    {/* Table Header */}
                    <div style={{ overflow: 'auto' }}>
                        <div style={{ borderBottom: '1px solid #21262d', background: '#161b22' }}>
                            <div className="user-details-table-elements" style={{ fontWeight: '600' }}>
                                <div style={{ minWidth: '50px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>ID</div>
                                <div style={{ minWidth: '250px', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Username</div>
                                <div style={{ minWidth: '250px', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Email</div>
                                <div style={{ minWidth: '100px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Country</div>
                                <div style={{ minWidth: '150px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Join Date</div>
                                <div style={{ minWidth: '150px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Balance</div>
                                <div style={{ minWidth: '150px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Total Earned</div>
                                <div style={{ minWidth: '150px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Banned</div>
                                <div style={{ minWidth: '100px', maxWidth: '100px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Check</div>
                            </div>
                        </div>

                        {/* Table Rows */}
                        {users.map((earning, i) => {
                            return (
                                <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: '#c9d1d9', borderBottom: '1px solid #21262d' }}>

                                    <div style={{ minWidth: '50px', color: '#e6edf3' }}>{earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '250px', textAlign: 'left', color: '#58a6ff' }}>{earning.username || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '250px', textAlign: 'left', color: '#c9d1d9' }}>{earning.email || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '100px', color: '#8b949e' }}>{earning.country || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '150px', color: '#8b949e' }}>{earning.joinDate || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '150px', color: '#3fb950' }}>{earning.balance || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{ minWidth: '150px', color: '#58a6ff' }}>{earning.total_earned || <Skeleton style={{ width: '30px' }} />}</div>
                                    <div style={{
                                        minWidth: '150px',
                                        color: earning.banned == undefined ? '#8b949e' : earning.banned == "True" ? '#f85149' : '#3fb950',
                                    }}>{earning.banned || <Skeleton style={{ width: '30px' }} />}</div>

                                    <Link to={`/pluto/user/${earning.id}`} style={{
                                        minWidth: '100px',
                                        height: '30px',
                                        display: 'flex',
                                        fontSize: '10px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        maxWidth: '100px',
                                        background: '#238636',
                                        border: '1px solid #2ea043',
                                        borderRadius: '6px',
                                        color: '#ffffff',
                                        fontWeight: '600',
                                        textDecoration: 'none',
                                        cursor: 'pointer'
                                    }}>{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Check User'}</Link>

                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>

        </SkeletonTheme>
    )
}

export default PlutoSameEmail
